import React, { useEffect } from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import { bonusPointsStyles as styles } from "./buyPoint.tailwind.js";
import BuyPointCheckoutInfo from "./BuyPointCheckoutInfo.jsx";
import { connect, useSelector } from "react-redux";
import StripeGateway from "./PaymentGateway/StripeGateway.jsx";
import { clearPurchasePointIntent } from "../../../../../redux/slices/rewardSlice.js";

const BuyPointsModal = ({ isOpen, onClose, clearPointIntent }) => {
  const { buyPoints } = useSelector(state => state.reward);

  useEffect(() => {
    clearPointIntent()
  }, [])

  return (
    <Modal open={isOpen}
      onClose={() => (buyPoints && buyPoints?.id) ? {} : onClose()}
      disableAutoFocus
      sx={{ padding: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <div className={styles.container}>
        <button onClick={onClose} className={styles.closeButtonContainer}>
          <CloseIcon sx={{ fontSize: '16px' }} />
        </button>

        <div className={styles.dataContainer}>
          {/* Modal Content */}
          {(buyPoints && buyPoints?.id) ? (
            <StripeGateway closeModal={onClose} clearPointIntent={clearPointIntent} />
          ) : (
            <BuyPointCheckoutInfo onClose={onClose} />
          )}
        </div> 
      </div>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => ({
  clearPointIntent: () => dispatch(clearPurchasePointIntent()),
});

export default connect(null, mapDispatchToProps)(BuyPointsModal);
